import request from '../common/request.js';


//添加单位
export function AddCompany(payload) {
    return request.post('/company/AddCompany', payload);
}

//获取单位列表
export function GetCompanyList(payload) {
    return request.post('/company/GetCompanyList', payload);
}

//更新单位列表
export function UpdateCompany(payload) {
    return request.post('/company/UpdateCompany', payload);
}

//删除单位列表
export function DeleteCompany(payload) {
    return request.get('/company/DeleteCompany', payload);
}

//获取省份列表
export function GetProvinceList(payload) {
    return request.get('/sys/GetProvinceList', payload);
}

//获取城市列表
export function GetCityList(payload) {
    return request.get('/sys/GetCityList', payload);
}

//获取地区列表
export function GetAreaList(payload) {
    return request.get('/sys/GetAreaList', payload);
}

//初始化人脸信息
export function InitCompanyFaces(payload) {
    return request.get('/company/InitCompanyFaces', payload);
}

//获取厂商列表
export function GetFaceFirmList(payload) {
    return request.get('/Face/GetFaceFirmList', payload);
}